export default "__VITE_ASSET__uuJSRRYQ__"